const CustomerScreenQuestion = require('../lib/CustomerScreen/CustomerScreenQuestion');
const CustomerScreenQuestionType = require('../lib/CustomerScreen/CustomerScreenQuestionType');
const { toInt, toString } = require('@/functions/transform');

/**
 * @constructor
 */
const MarketingPreference = function () {
    /**
     * @type {?number}
     */
    this.ID = null;

    /**
     * @type {string}
     */
    this.name = '';

    /**
     * @type {string}
     */
    this.question = '';

    /**
     *
     * @type {string}
     */
    this.status = '';
};

MarketingPreference.prototype = {
    getHydrationMap() {
        return {
            ID: {
                field: ['ID', 'marketingPreferenceID'],
                transform: toInt,
            },
            name: toString,
            question: toString,
            status: toString,
        };
    },

    /**
     * @return {CustomerScreenQuestion}
     */
    toCustomerScreenQuestion() {
        return new CustomerScreenQuestion(
            CustomerScreenQuestionType.BOOLEAN,
            this.question
        );
    },
};

module.exports = MarketingPreference;
